export default "__VITE_ASSET__CTjTmIm$__"